<template>
  <div>
    <topIcon :template="dominItem.templateId"  :nationId="dominItem.nationId" color="#082D48" noAbout="noAbout"></topIcon>
    <van-loading type="spinner" v-if="nodata"/>
    <div>
      <div class="logo" v-if="dominItem.templateId === 'temp1'">
        {{ dominItem.logoName || 'Logo' }}
        <div class="category" >
          <span v-for="item in typeList" @click="changeType(item.id)" :class="[{ choose: current === item.id }]">{{
              item.label
            }}</span>
        </div>
      </div>

      <div class="logo" v-if="dominItem.templateId === 'temp2'">
        <div class="category" >
          <span v-for="item in typeList" @click="changeType(item.id)" :class="[{ choose: current === item.id }]">{{
              item.label
            }}</span>
        </div>
        {{ dominItem.logoName || 'Logo' }}
      </div>

      <div class="logo" style="display: flex; flex-direction: column; padding-left: 20px" v-if="dominItem.templateId === 'temp3'">
        {{ dominItem.logoName || 'Logo' }}
        <div class="category" >
          <span v-for="item in typeList" @click="changeType(item.id)" :class="[{ choose: current === item.id }]">{{
              item.label
            }}</span>
        </div>

      </div>

    </div>
    <div style="padding: 0 10%;">
      <div class="news-page">
        <div class="news-page">
          <!-- 特色文章区域 -->
          <div class="featured-section">
            <div class="featured-big" @click="toDetail(bestItem.articleShortName)">
              <div class="featured-big-image-wrapper">
                <img :src="bestItem.articleImage" class="featured-big-image"/>
              </div>
              <div class="featured-big-content">
                <h2 class="featured-title">{{ bestItem.articleTitle }}</h2>
                <p class="featured-desc">{{ bestItem.articleSummary }}</p>
<!--                <div class="featured-meta">-->
<!--                  <span class="featured-date">{{ bestItem.uploadTime }}</span>-->
<!--                </div>-->
              </div>
            </div>

            <div class="featured-small-grid" v-if="articleList3.length > 0">
              <div v-for="(item, index) in articleList3" :key="item.id" class="featured-small" @click="toDetail(item.articleShortName)">
                <div class="featured-small-image-wrapper">
                  <img :src="item.articleImage" class="featured-small-image"/>
                </div>
                <div class="featured-small-content">
                  <h3 class="featured-small-title">{{ item.articleTitle }}</h3>
<!--                  <div class="featured-meta">-->
<!--                    <span class="featured-date">{{ item.uploadTime }}</span>-->
<!--                  </div>-->
                </div>
              </div>
            </div>
          </div>

          <!-- 主要文章网格 -->
          <div class="articles-grid"  v-if="articleList4.length > 0">
            <div v-for="item in articleList4" :key="item.id" class="article-card" @click="toDetail(item.articleShortName)">
              <div class="article-image-wrapper">
                <img :src="item.articleImage" class="article-image"/>
              </div>
              <div class="article-content">
                <h3 class="article-title">{{ item.articleTitle }}</h3>
                <p class="article-desc">{{ item.articleSummary }}</p>
                <div class="article-meta">
                  <span class="article-author">{{ item.authorName }}</span>
<!--                  <span class="article-date">{{ item.uploadTime }}</span>-->
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
        <div class="but-box">
          <div class="article-list-section">
            <h2 class="section-title">{{ $t('con_recommended') }}</h2>
            <div class="article-list"  v-if="articleListlast.length > 0">
              <div v-for="item in articleListlast" :key="item.id" class="article-item" @click="toDetail(item.articleShortName)">
                <div class="article-image-container">
                  <img :src="item.articleImage" class="article-image" />
                </div>
                <div class="article-text-container">
<!--                  <div class="article-meta">-->
<!--                    <span class="article-date">{{ item.uploadTime }}</span>-->
<!--                  </div>-->
                  <h3 class="article-title">{{ item.articleTitle }}</h3>
                  <p class="article-summary">{{ item.articleSummary }}</p>
                </div>
              </div>
            </div>
          </div>
      </div>
    </div>
    <div class="buttom">
      <div class="explore">
        <span style="color: #222222">{{ $t('con_Explore') }}</span>
        <span v-for="item in typeList" @click="changeType(item.id)"
              style="cursor: pointer; color: #000000">{{ item.label }}</span>
      </div>
<!--      <div class="logo" style="color: #222222;">{{ dominItem.logoName || 'Logo' }}</div>-->
      <footers is00="is03" :articleListlast="articleListlast" :current="current"></footers>
    </div>
  </div>
</template>

<script>
import {getOne, newContent} from "@/api"
import topIcon from '../../icons/small.vue'
import {format} from "date-fns";
import buttomIcon from '../../icons/big.vue'
import footers from "@/components/footContent/index.vue"

export default {
  components: {topIcon, buttomIcon, footers},


  props: {
    dominItem: Object
  },

  name: "index",
  data() {
    return {
      bestItem: {},
      nodata: false,
      // template: 'temp3',
      current: 1,
      recommendList: [],
      latestNewsList: [],
      articleList: [],
      articleList1: [],
      articleList2: [],
      articleList3: [],
      articleList4: [],
      articleListlast: [],
      recommendList1: [],
      typeList: [{label: this.$t('con_home'), id: 1},
        {label: this.$t('con_BUSINESS'), id: 2},
        {label: this.$t('con_NEWS'), id: 3},
        {label: this.$t('con_AllPRESS'), id: 4},
        {label: this.$t('con_LIFESTYLE'), id: 5},
        {label: this.$t('con_AUTO'), id: 6},
        {label: this.$t('con_TECHNOLOGY'), id: 7},
        {label: this.$t('con_about'), id: 8},
      ],
      iconListsmall: [
        {url: require('../../../assets/icon/linkedin.png'), link: 'https://www.linkedin.cn/'},
        {url: require('../../../assets/icon/facebook.png'), link: 'https://www.facebook.com/'},
        {url: require('../../../assets/icon/flipboard.png'), link: 'https://www.flipboard.cn/'},
        {url: require('../../../assets/icon/twitter.png'), link: 'https://twitter.com/'},
        {url: require('../../../assets/icon/instagram.png'), link: 'https://www.instagram.com/'},
      ],
    }
  },
  created() {
    this.nationId = JSON.parse(localStorage.getItem('dominItem')).nationId


    if (this.$route.query.type) {
      this.changeType(Number(this.$route.query.type))
    } else {
      this.getArticleList()
      this.getArticleListlast()
      this.getLatestNewsList()
      this.getRecommendList()
      this.getRecommendList1()
      this.getRecommendList2()
      this.getOneList()
    }
  },

  methods: {
    openLink(link) {
      window.open(link)
    },
    changeType(item) {
      if (item === 8) {
        item = 1
      }
      this.nodata = true
      this.current = item
      this.getArticleList()
      this.getArticleListlast()
      this.getLatestNewsList()
      this.getRecommendList()
      this.getRecommendList1()
      this.getRecommendList2()
      this.getOneList()
    },

    // 获取最新的一篇文章
    getOneList() {
      getOne({articleCategoryId: this.current, articleNationId: this.dominItem.nationId}).then(res => {
        if (!res.data.articleImage) {
          res.data.articleImage = require('@/assets/defore.jpg')
        }
        this.bestItem = res.data
        if (this.bestItem.uploadTime) {
          this.bestItem.uploadTime = format(new Date(this.bestItem.uploadTime), this.$t('con_format'))
        }
      })
    },


    // 获取推荐文章列表
    getArticleList() {
      newContent({
        articleCategoryId: this.current,
        pageNum: this.newsPageNum,
        pageSize: 10,
        articleNationId: this.nationId,
        articleType: 'con_recommended'
      }).then(res => {
        res.rows.map(r => {
          if (!r.articleImage) {
            r.articleImage = require('@/assets/defore.jpg')
          }
        })
        this.articleList = res.rows

        // this.articleList.map(r => {
        //   // r.uploadTime = format(new Date(r.uploadTime), this.$t('con_format'))
        // })
        this.nodata = false
      })
    },


    // 获取最新文章
    getLatestNewsList() {
      newContent({
        articleCategoryId: this.current,
        pageNum: this.newsPageNum,
        pageSize: 8,
        articleNationId: this.nationId,
        articleType: 'con_latest'
      }).then(res => {
        res.rows.map(r => {
          if (!r.articleImage) {
            r.articleImage = require('@/assets/defore.jpg')
          }
        })
        this.articleList1 = res.rows
        this.newsTotal = res.total
      })
    },

    //  获取热门文章
    getRecommendList() {
      newContent({
        articleCategoryId: this.current, pageNum: this.recommendPageNum, pageSize: 5,

        articleNationId: this.nationId, articleType: 'con_hot_con'
      }).then(res => {
        res.rows.map(r => {
          if (!r.articleImage) {
            r.articleImage = require('@/assets/defore.jpg')
          }
        })
        this.articleList2 = res.rows
      })
    },

    // 获取最新推荐
    getRecommendList1() {
      newContent({
        articleCategoryId: this.current,
        pageNum: 1,
        pageSize: 2,
        articleNationId: this.nationId,
        articleType: 'con_bestnew'
      }).then(res => {
        res.rows.map(r => {
          if (r.uploadTime) {
            r.uploadTime = format(new Date(r.uploadTime), this.$t('con_format'))
          }


          if (!r.articleImage) {
            r.articleImage = require('@/assets/defore.jpg')
          }
        })
        this.articleList3 = res.rows
      })
    },

    // 获取最新推荐
    getRecommendList2() {
      newContent({
        articleCategoryId: this.current,
        pageNum: 1,
        pageSize: 9,
        articleNationId: this.nationId,
        articleType: 'con_bestnew'
      }).then(res => {
        res.rows.map(r => {
          if (r.uploadTime) {
            r.uploadTime = format(new Date(r.uploadTime), this.$t('con_format'))
          }
          if (!r.articleImage) {
            r.articleImage = require('@/assets/defore.jpg')
          }
        })
        this.articleList4 = res.rows
      })
    },

    // 获取最下面文章列表  相关文章
    getArticleListlast() {
      // this.nodata = true
      newContent({
        articleCategoryId: this.current,
        pageNum: 3,
        pageSize: 6,
        articleNationId: this.nationId,
        articleType: 'con_related'
      }).then(res => {
        res.rows.map(r => {
          if (!r.articleImage) {
            r.articleImage = require('@/assets/defore.jpg')
          }
        })
        this.articleListlast = res.rows
        this.nodata = false
      })
    },

    //  查看详情
    toDetail(name) {
      this.$router.push(`/details/${name}?type=${this.current}`)
    }
  }
};
</script>

<style scoped lang="scss">
.news-page {
  margin: 20px 0;


  /* 特色文章区域样式 */
  .featured-section {
    display: grid;

    grid-template-columns: 2fr 1fr;
    gap: 20px;
    margin-bottom: 40px;
  }

  .featured-big {
    border-radius: 8px;
    position: relative;
    height: 400px;
    overflow: hidden;
    cursor: pointer;
  }

  .featured-big-image-wrapper {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }

  .featured-big-image {
    width: 100%;
    height: 100%;
    object-fit: cover;
    transition: transform 0.5s ease;
  }

  .featured-big:hover .featured-big-image {
    transform: scale(1.03);
  }

  .featured-big-content {
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    padding: 30px;
    background: linear-gradient(transparent, rgba(0, 0, 0, 0.8));
    color: white;
  }

  .featured-category {
    display: inline-block;
    padding: 3px 10px;
    background: #FC625C;
    color: white;
    font-size: 12px;
    font-weight: bold;
    margin-bottom: 10px;
    text-transform: uppercase;
  }

  .featured-title {
    font-size: 28px;
    margin: 0 0 10px 0;
    line-height: 1.3;
  }

  .featured-desc {
    font-size: 15px;
    margin: 0 0 15px 0;
    opacity: 0.9;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
  }

  .featured-meta {
    display: flex;
    justify-content: space-between;
    font-size: 14px;
    opacity: 0.8;
  }

  /* 小特色文章网格 */
  .featured-small-grid {
    display: flex;
    flex-direction: column;
    gap: 20px;
  }

  .featured-small {
    position: relative;
    height: 190px;
    border-radius: 8px;
    cursor: pointer;
    overflow: hidden;
  }

  .featured-small-image-wrapper {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }

  .featured-small-image {
    width: 100%;
    height: 100%;
    object-fit: cover;
    transition: transform 0.5s ease;
  }

  .featured-small:hover .featured-small-image {
    transform: scale(1.03);
  }

  .featured-small-content {
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    padding: 20px;
    background: linear-gradient(transparent, rgba(0, 0, 0, 0.8));
    color: white;
  }

  .featured-small-title {
    font-size: 16px;
    margin: 5px 0;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
  }

  /* 文章网格样式 */
  .articles-grid {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 25px;
  }

  .article-card {
    background: white;
    border-radius: 5px;
    overflow: hidden;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
    transition: transform 0.3s ease, box-shadow 0.3s ease;
    cursor: pointer;
  }

  .article-card:hover {
    transform: translateY(-5px);
    box-shadow: 0 5px 15px rgba(0, 0, 0, 0.1);
  }

  .article-image-wrapper {
    height: 180px;
    overflow: hidden;
  }

  .article-image {
    width: 100%;
    height: 100%;
    object-fit: cover;
    transition: transform 0.5s ease;
  }

  .article-card:hover .article-image {
    transform: scale(1.03);
  }

  .article-content {
    padding: 15px;
  }

  .article-category {
    display: inline-block;
    padding: 2px 8px;
    background: #f0f0f0;
    color: #333;
    font-size: 12px;
    margin-bottom: 8px;
    border-radius: 3px;
  }

  .article-title {
    font-size: 18px;
    margin: 0 0 10px 0;
    line-height: 1.4;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
  }

  .article-desc {
    font-size: 14px;
    color: #666;
    margin: 0 0 15px 0;
    line-height: 1.5;
    display: -webkit-box;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
    overflow: hidden;
  }

  .article-meta {
    display: flex;
    justify-content: space-between;
    font-size: 13px;
    color: #999;
  }
}

.but-box {
    margin: 40px 0;
    padding: 20px 0;
    border-top: 1px solid #eee;

  .article-list-section {
    margin-top: 30px;
  }

  .section-title {
    font-size: 22px;
    color: #222;
    margin-bottom: 20px;
    padding-bottom: 10px;
    border-bottom: 2px solid #000;
  }

  .article-list {
    display: flex;
    flex-direction: column;
    gap: 20px;
  }

  .article-item {
    display: flex;
    gap: 20px;
    cursor: pointer;
    transition: transform 0.2s ease;
    padding: 15px 0;
    border-bottom: 1px solid #f5f5f5;
  }

  .article-item:hover {
    transform: translateX(5px);
  }

  .article-image-container {
    flex-shrink: 0;
    width: 200px;
    height: 150px;
    overflow: hidden;

  }

  .article-image {
    width: 100%;
    height: 100%;
    object-fit: cover;
    transition: transform 0.3s ease;
  }

  .article-item:hover .article-image {
    transform: scale(1.05);
  }

  .article-text-container {
    flex-grow: 1;
    min-width: 0;
  }

  .article-meta {
    display: flex;
    justify-content: space-between;
    font-size: 13px;
    margin-bottom: 8px;
    color: #666;
  }

  .article-category {
    font-weight: 500;
    color: #004F8B;
  }

  .article-title {
    font-size: 18px;
    margin: 0 0 10px 0;
    line-height: 1.4;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
  }

  .article-summary {
    font-size: 14px;
    color: #666;
    line-height: 1.5;
    margin: 0;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
  }
}


.logo {
  width: 100%;
  display: flex;
  align-items: center;
  padding: 10px 10px 10px 10%;
  box-sizing: border-box;
  font-size: 40px;
  color: #ffffff;
  background: #0A3D62;
  justify-content: space-between;
  font-weight: bold;
  text-align: left;
}

.logo-temp1 {
  padding: 0 20px 0 10%;
}

.logo-temp2 {
}

.category {
  min-height: 40px;
  //margin-bottom: 30px;
  color: #ffffff;
  //border-top: 2px solid var(--themeColor);
  //border-bottom: 2px solid var(--themeColor);
  line-height: 38px;

  span {
    font-weight: 500;
    font-size: 18px;
    display: inline-block;
    padding: 0 20px;
    cursor: pointer;
    position: relative;
  }

  span:hover {
    color: red;
    transition: all .1s ease;
  }

  .choose {
    transition: all .1s ease;
    color: red;;
  }
}

.buttom {
  background: #F4F4F4;
  border-top: 2px solid #000000;
  display: flex;
  flex-direction: column;

  .logo {
    width: 80%;
    margin: auto;
    background: transparent;
    display: flex !important;
    align-items: center !important;
    justify-content: center !important;
    text-align: center !important;
  }

  display: flex;

  .explore {
    display: flex;
    justify-content: center;
    margin-top: 30px;
    margin-bottom: 20px;
    align-items: center;

    span:first-child {
      color: #004F8B;
      font-size: 18px;
      font-weight: bold;
      margin-right: 30px;
    }

    span {
      margin-right: 10px;
      font-size: 15px;
    }
  }
}

.about {
  cursor: pointer;
  height: 40px;
  line-height: 40px;
  font-weight: 400;
  font-size: 17px;
  text-transform: uppercase;
  display: flex;
  justify-content: end;
  //justify-content: space-between;
  padding-right: 20px;
  color: #ffffff;
  background: #000000;
  align-items: center;

  span {
    margin-left: 20px;
    margin-right: 20px;
  }

  img {
    width: 20px;
    height: 20px;
  }

  img:nth-child(4) {
    width: 30px;
    height: 30px;
  }

  img:nth-child(5) {
    width: 30px;
    height: 30px;
  }

  img:nth-child(6) {
    width: 30px;
    height: 30px;
  }
}


.content {
  padding: 0 10% 20px;
  display: flex;
  flex-wrap: wrap;

  span {
    display: inline-block;
    margin-bottom: 10px;
    width: 50%;
  }
}

.imgsss {
  width: 30px;
  height: 30px;
}

.imgsss:nth-child(4) {
  width: 40px;
  height: 40px;
}

.imgsss:nth-child(5) {
  width: 40px;
  height: 40px;
}

.imgsss:nth-child(6) {
  width: 40px;
  height: 40px;
}

.article-image1 {
  width: 80px;
  height: 80px;
  object-fit: cover;
}

</style>
